module.exports = __webpack_public_path__ + "img/22.b305bc30.png";